import { FormControl, Grid, InputAdornment } from "@mui/material";
import { connect, Field } from "formik";
import { TextField } from "formik-mui";
import { FormikAutocomplete } from "../../../components/common/FormkikAutocomplete";
import Maybe from "../../../components/common/Maybe";
import { countries } from "../../../data/countries";
import { states } from "../../../data/states";
import { HelpIconInterface, Microcopy } from "../../../utilities/contentful";
import FormHelpLabel from "../../common/FormHelpLabel";
import { RequestFamilyMember } from "../../purchase/PurchaseData.interface";

const formatCurrency = (value: string) => {
  const removeNonNumeric = value
    .replace(/[^0-9\\.]+/g, '')
    .replace('.', 'A')
    .replace(/\./g, '')
    .replace('A', '.')

  const toNumeric = Number(removeNonNumeric);

  return toNumeric === 0 ? '' : toNumeric.toFixed(2);
}

const micro = new Microcopy;

const IndividualRequest = (props: { helpIcons: HelpIconInterface[], formik?: any, fieldName: string, individual: Partial<RequestFamilyMember>, microcopy: any }): JSX.Element => {

  return (
    <Grid container rowSpacing={2} columnSpacing={4}>

      <Grid item xs={12} sm={6} md={4}>
        <FormControl fullWidth>
          <FormHelpLabel helpIcons={props.helpIcons} label={micro.getFromKey('field.age', props.microcopy)} contentfulId={''} hideHelp />
          <Field
            component={TextField}
            placeholder={'Age'}
            name={`${props.fieldName}.age`}
            onBlur={props.formik.handleBlur}
            // onChange={props.formik.handleChange}
            type="number"
          />
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <FormHelpLabel helpIcons={props.helpIcons} label={micro.getFromKey('field.gender', props.microcopy)} contentfulId={''} hideHelp />
        <Field
          component={FormikAutocomplete}
          name={`${props.fieldName}.genderObject`}
          options={[
            { "value": "female", "label": micro.getFromKey('option.female', props.microcopy) }, 
            { "value": "male", "label": micro.getFromKey('option.male', props.microcopy) }
          ]}
          textFieldProps={{ placeholder: micro.getFromKey('field.gender', props.microcopy) }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <Maybe test={props.formik.values.tripProtection == 'yes' && props.formik.values.useOverallTripCost == 'no'}>
          <FormControl fullWidth>
            <FormHelpLabel helpIcons={props.helpIcons} label={micro.getFromKey('field.individual-cost', props.microcopy)} contentfulId={''} hideHelp />
            <Field
              component={TextField}
              placeholder={micro.getFromKey('field.individual-cost', props.microcopy)}
              name={`${props.fieldName}.tripCost`}
              type="text"
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>,
              }}
              // onChange={props.formik.handleChange}
              onBlur={(event: any) => {
                const formatted = formatCurrency(props.individual.tripCost as string);
                props.formik.setFieldValue(`${props.fieldName}.tripCost`, formatted);
                props.formik.handleBlur(event);
                props.formik.handleChange(event);
              }}
            />
          </FormControl>
        </Maybe>
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <FormHelpLabel helpIcons={props.helpIcons} label={micro.getFromKey('field.citizenship', props.microcopy)} contentfulId={'1KLr9qmJ0rnwdjjxokvn0I'} />
        <Field
          component={FormikAutocomplete}
          name={`${props.fieldName}.citizenshipObject`}
          textFieldProps={{placeholder:'Citizenship'}}
          options={[{ "value": "USA", "label": "United States" }, ...countries]}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <FormHelpLabel helpIcons={props.helpIcons} label={micro.getFromKey('field.country-residence', props.microcopy)} contentfulId={'3VSYaUPwWiTpJ1WMh8cOnX'} />
        <Field
          component={FormikAutocomplete}
          name={`${props.fieldName}.residencyCountryObject`}
          options={[{ "value": "USA", "label": "United States" }, ...countries]}
          textFieldProps={{ placeholder: 'Country' }}
        />
      </Grid>

      <Maybe test={props.individual.residencyCountryObject?.value == 'USA'}>
        <Grid item xs={12} sm={6} md={4}>
          <FormHelpLabel helpIcons={props.helpIcons} label={micro.getFromKey('field.state-residence', props.microcopy)} contentfulId={'2PVf1Jgy4QeDvbN8RxT0Ef'} />
          <Field
            component={FormikAutocomplete}
            name={`${props.fieldName}.residencyStateObject`}
            options={states}
            textFieldProps={{ placeholder: 'State' }}
          />
        </Grid>
      </Maybe>
    </Grid>
  );
}

export default connect(IndividualRequest);